import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import style from './styles.module.less';
import { MessageDescriptorPropType } from '../../../prop-types/intl';

/**
 * Dangerous goods cell component
 * @param {object} props - component props
 * @param {MessageDescriptorPropType} props.header - header message descriptor
 * @param {string|number} props.value - cell value
 * @returns {JSX.Element}
 */
export const DangerousGoodsCell = ({ header, value = '' }) => {
  return (
    <div>
      <div className={style['dangerous-goods-row-title']}>
        <FormattedMessage {...header} />
      </div>
      <div className={style['dangerous-goods-row-value']}>{value}</div>
    </div>
  );
};

DangerousGoodsCell.propTypes = {
  header: MessageDescriptorPropType.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
